import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog'; import { AccountingImportComponent } from './accounting-import.component';
import { AccountingAccountsService } from '../accounting-accounts/accounting-accounts.service';

@Component({
    selector: 'convfact-importSumasSaldos',
    templateUrl: './import-sumas-saldos.component.html',
    styleUrls: ['./accounting-import.component.scss'],
    standalone: false
})
export class ImportSumasSaldosComponent {

    constructor(
        public dialogRef: MatDialogRef<AccountingImportComponent>,
        public accountingService: AccountingAccountsService,
        public snackBar: MatSnackBar
    ) { }

    fileName: string;
    selectedDate: Date;
    ready = true;

    onFileSelected(event: any) {
        const file: File = event.target.files[0];
        if (file) {
            this.fileName = file.name;
        }
    }

    displayInfo(message: string): void {
        const options = new MatSnackBarConfig();
        options.duration = 7500;
        options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
    }

    createFormData(): FormData {
        const formData = new FormData();
        const fileInput = (document.getElementById('fileInput') as HTMLInputElement);
        if (fileInput.files && fileInput.files.length > 0) {
            formData.append('file', fileInput.files[0], fileInput.files[0].name);
        }

        if (this.selectedDate) {
            formData.append('date', this.selectedDate.toISOString());
        }
        return formData;
    }

    uploadFile() {
        this.ready = false;
        if (!this.fileName) {
            alert('Por favor selecciona un archivo primero.');
            this.ready = true;
            return;
        }
        if (!this.selectedDate) {
            alert('Por favor selecciona una fecha.');
            this.ready = true;
            return;
        }
        // Lógica para subir archivo
        this.accountingService.importSumasSaldos(this.createFormData()).then(response => {
            this.ready = true;
            const msg = response && response.message ? response.message : 'Importación completada con éxito.';
            this.snackBar.open(msg, '', { duration: 8000 });
            this.close();
        }).catch(error => {
            console.error(error);
            this.ready = true;
            this.snackBar.open('Error durante la importación: ' + error.message, '', { duration: 10000 });
            this.close();
        });
    }

    public close() {
        this.dialogRef.close();
    }

}
